import { clearLoginKey } from "./requestSigning";

/**
 * Customer portal session. The access token is bound to this browser's
 * "customer" signing key (see requestSigning.js) and sent by api-handler on
 * every request made from a /customer-portal page.
 */
export const CUSTOMER_TOKEN_KEY = "customer_access_token";

export const getCustomerToken = () => {
	try {
		return window.localStorage.getItem(CUSTOMER_TOKEN_KEY) || "";
	} catch (_) {
		return "";
	}
};

/** Store a successful sign in response (`data` of sign_in / sign_in_with_company). */
export const setCustomerSession = (data = {}) => {
	try {
		if (data.access_token) window.localStorage.setItem(CUSTOMER_TOKEN_KEY, data.access_token);
		window.localStorage.setItem("customerLoggedIn", "true");
		window.localStorage.setItem("customerShipmentList", JSON.stringify(data.shipment_jobs || []));
		if (data.company_id) window.localStorage.setItem("customerCompanyId", data.company_id);
	} catch (_) { }
};

export const clearCustomerSession = () => {
	try {
		window.localStorage.removeItem(CUSTOMER_TOKEN_KEY);
		window.localStorage.removeItem("customerLoggedIn");
		window.localStorage.removeItem("customerShipmentList");
	} catch (_) { }
	clearLoginKey("customer");
};
